
//import '../../Styles/css/Day.css';

import { Add, Close, Remove } from '@mui/icons-material';
import { Button, IconButton } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import useCraRdv from '../../hooks/useCraRdv';
import useRole from '../../hooks/useRole';
import { buttonStylesGreen } from '../docsAdministrative/JsObjectStyles';
import { TextFieldComponent } from '../shared/ReusableSmallComponents';
// import { ColorBox } from './Day';

//var lbC = { dict: { '1': 'green', '0.5': 'indigo', '0': 'red' } };
//var lbC = { dict: { '1': '#C3C9F1', '0.5': '#E7EAF9', '0': 'gray' } };

export default function EventModal({ evts, idCra, holidaysDuMoisDuCra, refreshCra }) {
    EventModal.propTypes = {
        evts: PropTypes.array,
        idCra: PropTypes.any,
        holidaysDuMoisDuCra: PropTypes.any,
        onClickOut: PropTypes.func,
        refreshCra: PropTypes.func,
    };
    const axiosPrivate = useAxiosPrivate();
    const role = useRole();
    const { i18n } = useTranslation();
    const {
        setShowEventModal,
        daySelected,
        selectedEvent,
    } = useCraRdv();

    const [counter, setCounter] = useState(
        selectedEvent ? selectedEvent.counter : 1);

    const [description, setDescription] = useState(
        selectedEvent ? selectedEvent.description : ''
    );
    const day = daySelected.format('DD-MM-YYYY');
    //=================================isHoliday=========================================
    //! WHY WE ARE DOING THAT HERE, ALREADY exists in another page
    function isHoliday(day) {
        if (day.format('dddd').toUpperCase() === 'SAMEDI' || day.format('dddd').toUpperCase() === 'DIMANCHE' || holidaysDuMoisDuCra.indexOf(day.format('DD-MM-YYYY')) !== -1) {
            return true;
        }
        return false;
    }

    //=================== default day color if it's holiday weekend...============
    //function ColorIfOrNotHoliday(day, counter) {
    //    if (isHoliday(day)) {
    //        return 'gray';
    //    }
    //    return lbC.dict[counter];
    //}
    //========================submit===============================================
    function handleSubmit(e) {
        e.preventDefault();
        var evt = {
            expert: 'expert',
            client: null,
            counter,
            description,
            // label:ColorBox(isHoliday(day),counter),
            day: daySelected.format('DD-MM-YYYY'),
            idCra: idCra,
            isHoliday: isHoliday(daySelected),
            idDay: day + idCra
        };
        console.log('toto', evts);
        // * NEW
        axiosPrivate
            .post('/event/addEvent/', evt)
            .then(()=> {
                setShowEventModal(false);
                refreshCra();
            });
    }

    //========================delete===============================================
    //? no need for delete, since we can always set it event at 0 or 1
    // function deleteEvent(day) {
    //     axiosPrivate
    //         .delete('/event/deleteEvent/' + day + idCra)
    //         .then(() => {
    //             console.log('deleted');
    //         });
    // }
    //==========================counter=============================================
    //increase counter
    const increase = () => {
        if (counter < 1) {
            setCounter(count => count + 0.5);
        }
        if (counter === 1) {
            setCounter(count => count);
        }
        setShowEventModal(true);
    };
    //decrease counter
    const decrease = () => {
        if (counter > 0) {
            setCounter(count => count - 0.5);
        }
        if (counter === 0) {
            setCounter(0);
        }
        setShowEventModal(true);
    };
    //========================use Effect===============================================
    useEffect(() => {
    }, [evts, idCra]);
    //========================return===============================================
    return (
        <div
            // className="h-screen w-full fixed left-0 top-0 flex justify-center items-center"
            style={{
                height: '100vh',
                width: '100%',
                position: 'fixed',
                left: 0,
                top: 0,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 100
            }}
        >
            <form
                // className="bg-white rounded-lg  width: 30px padding: 10px height: 30px"
                style={{
                    backgroundColor: '#ffffff',
                    borderRadius: '0.5rem',
                }}
            >
                <header
                    // className="bg-gray-100 px-4 py-2 flex justify-between items-center"
                    style={{
                        display: 'flex',
                        paddingTop: '0.5rem',
                        paddingBottom: '0.5rem',
                        paddingLeft: '1rem',
                        paddingRight: '1rem',
                        backgroundColor: '#F3F4F6',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <div>
                        <IconButton
                            //  contained
                            sx={{ color: '#272D3C', padding: '0px' }}
                            onClick={() => setShowEventModal(false)}
                        >
                            <Close />
                        </IconButton>
                    </div>
                </header>

                <div /* className="p-3" */ style={{ padding: '3px' }}>
                    <div /* className="grid grid-cols-1/5 items-end gap-y-7" */
                        style={{ display: 'grid', gridTemplateColumns: '1/5', gridGap: '7px', alignItems: 'end' }}
                    >
                        <p className='Titlef11 FMonthWrap'> {i18n.t('Ajouter une note')}</p>
                        <TextFieldComponent
                            name="description"
                            placeholder={i18n.t('Ajouter une note')}
                            value={description}
                            // required
                            multiline
                            rows={2}
                            maxRows={5}
                            /* className="pt-3 border-0 text-gray-600 pb-2 w-full border-b-2 border-gray-200 focus:outline-none focus:ring-0 focus:border-blue-500" */
                            style={{ paddingTop: '3px', border: '0', color: '#6c757d', paddingBottom: '2px', width: '100%', borderBottom: '2px solid #6c757d', outline: 'none', borderRadius: '0', borderColor: '#17a2b8' }}
                            onChange={(e) => setDescription(e.target.value)}
                        />
                    </div>
                </div>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                >
                    <div>
                        <IconButton
                            onClick={increase}
                            aria-label="first page"
                        >
                            <Add />
                        </IconButton>
                        <span
                            style={{ fontSize: 'large' }}
                        >{counter}</span>
                        <IconButton
                            onClick={decrease}
                            aria-label="first page"
                        >
                            <Remove />
                        </IconButton>
                    </div>
                </div>

                <footer
                    /* className="flex justify-end border-t p-3 mt-5" */
                    style={{ display: 'flex', justifyContent: 'flex-end', borderTop: '1px solid #6c757d', padding: '3px', marginTop: '5px' }}
                >
                    <Button
                        type="submit"
                        variant='contained'
                        onClick={(e)=> {if(role=='expert')handleSubmit(e);}}
                        style={{...buttonStylesGreen(false),
                            ...{width: '430px',height: '36px'}
                        }}
                    >
                        {i18n.t('Enregistrer')}
                    </Button>
                </footer>

            </form>
        </div>
    );
}
